import {
  cn
} from "./chunk-DYSUVPH5.mjs";

// src/components/input/input-v2.tsx
import { cva } from "class-variance-authority";
import React, { forwardRef } from "react";
var DEFAULT_SIZE = "md";
var inputVariants = cva(
  "flex w-full rounded-md bg-interactive-surface px-3 text-foreground-subtle caret-[theme(backgroundColor.interactive-accent-surface-active)] ring-1 ring-inset ring-[theme(backgroundColor.interactive-surface)] transition-colors duration-300 ease-out placeholder:text-foreground-disabled read-only:text-foreground-disabled focus-visible:bg-surface focus-visible:outline-none focus-visible:ring-focus disabled:cursor-not-allowed disabled:text-foreground-disabled",
  {
    variants: {
      size: {
        md: "py-[9px] my-body-sm",
        lg: "py-3 my-body-md"
      },
      error: {
        true: "ring-semantic-critical"
      },
      positive: {
        true: "ring-semantic-success"
      },
      warning: {
        true: "ring-semantic-warning"
      }
    },
    defaultVariants: {
      size: DEFAULT_SIZE,
      error: false,
      positive: false,
      warning: false
    }
  }
);
var InputV2Component = forwardRef(
  ({ className, size, htmlSize, error, positive, warning, type, ...props }, ref) => {
    return /* @__PURE__ */ React.createElement(
      "input",
      {
        type,
        className: cn(
          inputVariants({ size, error, positive, warning, className })
        ),
        size: htmlSize,
        ref,
        ...props
      }
    );
  }
);
var InputV2 = Object.assign(InputV2Component, {
  id: "InputV2"
});

export {
  InputV2
};
